import React from 'react';
import { Table, Avatar } from "tabler-react";

const RecordsTable = ({ headers, records }) => {
  return (
    <Table
      hasOutline
      striped
    >
      <Table.Header>
        {headers.map((head, i) => (
          <Table.ColHeader
            key={`tableHeader-${i}`}
          >
            {head}
          </Table.ColHeader>
        ))}
      </Table.Header>
      <Table.Body>
        {records.map((r, i) => (
          <Table.Row key={i}>
            {Object.keys(r).map((k, i) => {
              if (k === 'id' || k === 'roles') { return false }
              if (k === 'owner') {
                return (
                  <Table.Col>
                    <Avatar size="sm" imageURL={r['owner']['img']} />
                    &nbsp;
                    {r['owner']['username']}
                  </Table.Col>
                );
              }
              return (<Table.Col>{r[k]}</Table.Col>);
            })}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default RecordsTable;